import { useTranslation } from 'react-i18next';
import CatalogListHeader from '../../../components/CatalogListHeader/CatalogListHeader';
import { Text } from '@mantine/core';
import { useLocation } from 'react-router-dom';
import CatalogContainer from '../../../components/CatalogContainer/CatalogContainer';
import { useSelector } from 'react-redux';
import ServicesToDeliverReportContent from './ServicesToDeliverReportContent';

export interface ServicesToDeliverSummaryItem {
  sectionId: string | null;
  sectionName: string;
  serviceName: string;
  displayName: string;
  selectedOptionLabel: string;
  productType: 'weight' | 'length' | 'normal';
  unitLabel: string;
  totalQuantity: number;
  linesCount: number;
  ordersCount: number;
}

export interface ServicesToDeliverDetailItem {
  orderId: string;
  lineId: string;
  storeId: string;
  storeName: string;
  folio: string;
  deliveryDate: string;
  fromTime: string;
  toTime: string;
  customerName: string;
  customerPhone: string;
  sectionId: string | null;
  sectionName: string;
  serviceName: string;
  displayName: string;
  selectedOptionLabel: string;
  quantity: number;
  productType: 'weight' | 'length' | 'normal';
  unitLabel: string;
  lineStatus: string;
  isFinished: boolean;
  total: number;
  paidAmount: number;
  balance: number;
}

const ServicesToDeliverReport = () => {
  const { t } = useTranslation(['ReportsPage']);
  const location = useLocation();
  const {
    company: { _id: companyId }
  } = useSelector((state: any) => state.user);
  const searchParams = new URLSearchParams(location.search);
  const searchParamStoreId = searchParams.get('storeId') || 'all';

  return (
    <CatalogContainer>
      <CatalogListHeader
        title={t('ReportsPage:servicesToDeliverReport.title')}
        showCreateButton={false}
      />
      <Text c="dimmed" size="sm" mb="sm">
        {t('ReportsPage:servicesToDeliverReport.subtitle')}
      </Text>
      <ServicesToDeliverReportContent
        companyId={companyId}
        storeId={searchParamStoreId}
      />
    </CatalogContainer>
  );
};

export default ServicesToDeliverReport;
